module.exports = __webpack_public_path__ + "f44e2094daab5f6719f7bda9938e4e0e.webp";